import { render, staticRenderFns } from "./otherPurchaseCompleted.vue?vue&type=template&id=6b57bab2&scoped=true"
import script from "./otherPurchaseCompleted.vue?vue&type=script&lang=js"
export * from "./otherPurchaseCompleted.vue?vue&type=script&lang=js"
import style0 from "./otherPurchaseCompleted.vue?vue&type=style&index=0&id=6b57bab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b57bab2",
  null
  
)

export default component.exports